import { useTheme } from "next-themes"
import { Toaster as Sonner } from "sonner-original"

// TOAST-UX-001: durations per type come from src/lib/sonner.js (the `sonner` alias); `duration` here is the fallback.
const Toaster = ({
  ...props
}) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme}
      className="toaster group"
      position="top-right"
      offset={{ top: 72, right: 24, bottom: 32, left: 24 }}
      mobileOffset={{ top: 64, right: 16, bottom: 24, left: 16 }}
      gap={10}
      expand
      duration={2000}
      visibleToasts={4}
      closeButton
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-white group-[.toaster]:text-slate-900 group-[.toaster]:border group-[.toaster]:border-slate-200 group-[.toaster]:shadow-2xl group-[.toaster]:rounded-xl",
          description: "group-[.toast]:text-slate-600 group-[.toast]:text-sm group-[.toast]:mt-1",
          actionButton:
            "group-[.toast]:bg-indigo-600 group-[.toast]:text-white group-[.toast]:rounded-lg group-[.toast]:px-4 group-[.toast]:py-2 group-[.toast]:font-medium group-[.toast]:hover:bg-indigo-700",
          cancelButton:
            "group-[.toast]:bg-slate-100 group-[.toast]:text-slate-700 group-[.toast]:rounded-lg group-[.toast]:px-4 group-[.toast]:py-2 group-[.toast]:hover:bg-slate-200",
          success: "titleflow-success-toast",
          error: "titleflow-error-toast",
          warning: "titleflow-warning-toast",
          info: "titleflow-info-toast",
        },
        style: {
          borderRadius: '12px',
          padding: '16px',
          fontSize: '14px',
          fontWeight: '500',
        }
      }}
      {...props} />
  );
}

export { Toaster }
